export default __webpack_public_path__ + "static/Precise_Website_Terms_of_Use-e5c8b3bfcf8b60672fadc7891ace56c7.pdf";